import * as type from './type'
import { get } from '../../../../util/api'

export const getVersionSummaryRequest = () => ({
    type: type.GET_VERSION_SUMMARY_REQUEST,
    payload: {},
})

export const getVersionSummarySuccess = (versionSummary) => ({
    type: type.GET_VERSION_SUMMARY_SUCCESS,
    payload: {
        versionSummary,
    },
})

export const getVersionSummaryError = (error) => ({
    type: type.GET_VERSION_SUMMARY_ERROR,
    payload: {
        error,
    },
})

export const getVersionSummary = () => (dispatch, getState) => {
    dispatch(getVersionSummaryRequest())

    get('/process/version/summary')
        .then(versionSummary => {
            dispatch(getVersionSummarySuccess(versionSummary))
        })
        .catch(error => {
            dispatch(getVersionSummaryError(error))
        })
}




// WEBPACK FOOTER //
// ./src/modules/process/state/version-summary/action.js